// extracted by mini-css-extract-plugin
export default {"title":"FoundersSection_title__UzR8H","frameParent":"FoundersSection_frameParent__F78Kh","sectioncreator":"FoundersSection_sectioncreator__fC020"};